export const loginText = `
<a href="{loginLink}">Log in</a> to view your highlights and notes.
`;
